// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="chakra-icon chakra-icon css-1j9in0o"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.226 11c-1.051 0-1.613-1.268-.92-2.077l5.405-6.324a1.687 1.687 0 012.578 0l5.406 6.324c.692.81.13 2.077-.921 2.077H6.226z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.13 15H7.87L12 19.831 16.13 15zm-2.84 6.401a1.687 1.687 0 01-2.58 0l-5.405-6.324c-.692-.81-.13-2.077.921-2.077h11.548c1.051 0 1.613 1.268.92 2.077l-5.405 6.324z"
      clipRule="evenodd"
    />
  </svg>
);
const IconSortAsc = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconSortAsc;
